import React from 'react';
import SiteLayout from '../../../../layouts/SiteLayout/SiteLayout';
import BaseSectionWrapper from '../../../../siteBaseSections/baseSectionComponents/BaseSectionWrapper/BaseSectionWrapper';
import SetupCompleteMessage from '../../../../delegateJourney/SetupCompleteMessage/SetupCompleteMessage';

export default function SetupCompleteView() {
  return (
    <SiteLayout
      helmet={{ title: 'Account setup is complete' }}
      style={{
        background: 'linear-gradient(180deg, #EFEFEF 0%, #FFFFFF 100%)',
      }}
    >
      <BaseSectionWrapper section={{ type: 'setup_complete_message' }}>
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-8">
              <SetupCompleteMessage />
            </div>
          </div>
        </div>
      </BaseSectionWrapper>
    </SiteLayout>
  );
}
